<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Add Subcategory</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="submit" enctype="multipart/form-data">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Category<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.subcategorydata.categoryid.$model">
                                <option disabled value>Select category</option>
                                <option v-for="(list, index) in category" :value="list.categoryid" :key="index">
                                    {{ list.categoryname }}
                                </option>
                            </select>
                            <div class="error" v-if="submitted && !$v.subcategorydata.categoryid.required">Please select category</div>
                        </div>

                        <div class="col-md-4">
                            <label>Subcategory<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.subcategorydata.subcategoryname.$model" type="text" label="Category" placeholder="Enter subcategory" />
                            <div class="error" v-if="submitted && !$v.subcategorydata.subcategoryname.required">Please enter subcategory</div>

                        </div>

                        <div class="col-md-4">
                            <label>Image<em style="color:red">*</em></label>
                            <input class="form-control" type="file" label="Image" name="subcategoryimage" id="categoryimage" @change="onFileSelected" accept="image/x-png,image/gif,image/jpeg" />
                            <div class="error" v-if="submitted && !$v.subcategorydata.subcategoryimage.required">Please select image</div>

                        </div>

                    </div><br>

                    <div class="row">
                        <div class="col-md-4">
                            <label>Status<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.subcategorydata.subcategorystatus.$model">
                                <option disabled>Select status</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                            </select>
                            <div class="error" v-if="submitted && !$v.subcategorydata.subcategorystatus.required">Please select status</div>
                        </div>

                    </div>

                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Add Subcategory</button>&nbsp;
                        <router-link to="/admin/dashboard/subcategory"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>

                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
    file_size_validation,
} from "vuelidate/lib/validators";
import {
    exit
} from "process";
export default {
    name: 'addSubcategory',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,

    },

    data() {
        return {
            submitted: false,
            category: [],
            subcategorydata: {
                categoryid: '',
                subcategoryname: '',
                subcategoryimage: [],
                subcategorystatus: '1',
            }
        }
    },

    validations: {
        subcategorydata: {
            categoryid: {
                required,
            },
            subcategoryname: {
                required,
            },
            subcategoryimage: {
                required,
            },
            subcategorystatus: {
                required,
            },
        }
    },

    methods: {

        onFileSelected(event) {
            this.subcategorydata.subcategoryimage = event.target.files[0];
        },

        submit() {

            let formData = new FormData();
            formData.append('categoryid', this.subcategorydata.categoryid);
            formData.append('subcategoryname', this.subcategorydata.subcategoryname);
            formData.append('subcategoryimage', this.subcategorydata.subcategoryimage);
            formData.append('subcategorystatus', this.subcategorydata.subcategorystatus);

            this.submitted = true;
            this.$v.$touch()

            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/addsubcategory`, formData)
                    .then(({
                        data
                    }) => {
                        this.$router.push('/admin/dashboard/subcategory');
                        this.flashMessage.success({
                            message: 'Subcategory Added Successfully',
                        });
                    })
                // .catch((error) => {
                //     console.log(error);
                // });

            }
        }
    },

    mounted() {
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivecategory`).then((res) => {
            this.category = res.data;
        });
    },

};
</script>

<style lang="scss">
</style>
